/**
 * WebEngage Custom Events Integration - Search Only
 */
(function () {
  'use strict';

  // Debug Logger Helper
  function logDebug(...args) {
    if (window.WE_DEBUG || (typeof window.location !== 'undefined' && window.location.search.includes('we_debug=true'))) {
      console.log('[WebEngage-Custom-Events]', ...args);
    }
  }

  function logError(error, context) {
    console.error(`[WebEngage-Custom-Events] Error in ${context}:`, error);
  }

  // Safety utility to check if WebEngage is ready
  function webengageOnReady(callback) {
    if (window.webengage && typeof window.webengage.track === 'function') {
      callback();
    } else {
      const interval = setInterval(() => {
        if (window.webengage && typeof window.webengage.track === 'function') {
          clearInterval(interval);
          callback();
        }
      }, 500);
      setTimeout(() => clearInterval(interval), 10000);
    }
  }

  // Central Event Dispatcher
  function trackEvent(eventName, payload) {
    try {
      logDebug(`Attempting to track: ${eventName}`, payload);
      webengageOnReady(() => {
        window.webengage.track(eventName, payload);
        console.log('[WebEngage Track]', eventName, payload);
      });
    } catch (e) {
      logError(e, `trackEvent(${eventName})`);
    }
  }

  // Searched Product
  function initSearchTracking() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const query = urlParams.get('q') || '';
      
      if (query && (window.location.pathname.includes('searchtap-search') || window.location.pathname.includes('/search'))) {
        logDebug('SearchTap search page detected, waiting for results...');

        let attempts = 0;
        const interval = setInterval(() => {
          attempts++;
          const countElement = document.querySelector('.st-stats, .st-results-count, #st-stats, .st-record-count, .st-stats-container');
          const productCards = document.querySelectorAll('#st-results-list .st-outer-box, .st-product-card, .st-search-result-item');

          if (countElement || productCards.length > 0 || attempts > 20) {
            clearInterval(interval);

            let totalItems = 0;
            if (countElement) {
              const text = countElement.textContent || '';
              const match = text.match(/\d+/g);
              if (match && match.length > 0) {
                totalItems = Number(match[match.length - 1]);
              }
            } else {
              totalItems = productCards.length;
            }

            const payload = {
              'Source': 'Shopify',
              'Terms': String(query),
              'Total Items': Number(totalItems)
            };
            trackEvent('Searched Product', payload);
          }
        }, 500);
      }
    } catch (e) {
      logError(e, 'initSearchTracking');
    }
  }

  // Initialize
  function initAll() {
    logDebug('Initializing search tracking...');
    initSearchTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
